import {ApiPaths, ApiService, SetAuthToken, ApiStatus} from '../../utils/ApiService';
import {GET_PROJECTS } from './types';
import{MAIN_LOAD_TRUE, MAIN_LOAD_FALSE} from '../User/types';
import {displayMessage, displayError, mainLoadingTrue, mainLoadingFalse} from '../User/action'
const UserData = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null ;

export const GetProjects_action = (data) => {
    return dispatch => {
        dispatch(mainLoadingTrue());
        if(UserData){
        const body = {
            mobileNumber : UserData["crm_customer_contact_no_one"],
            userID : UserData["crm_customer_details_id"],
            "locationID":"",
            "enquirySourceID":0,
            "customerMobileNo":"",
            "enquiryNumber":"",
            "followUpFromDate":"",
            "followUpToDate":"",
            "followUpInterestStatus":"",
            "projectID":0,
            "generalSearch":"",
            "sortOrder":"",
            "followUpType":"",
            ...data
        }
        return ApiService.post(ApiPaths.GET_PROJECTS, body)
            .then(response => {
                const { data } = response;
                dispatch(mainLoadingFalse());
                if(!data.error) {
                    dispatch(getProjects(data.project));
                    dispatch(displayMessage(data.message));
                } else {
                    dispatch(displayError(data.message));
                }
            })
            .catch(err => {
                dispatch(mainLoadingFalse());
                displayError('Failed, try again later');
            })
        }else{
            console.log("redirect to home")
        }
    }
}

export const getProjects = (data) => {
    return {
        type : GET_PROJECTS,
        payload : {data}
    }
}

